module.exports = __webpack_public_path__ + "img/nishio-takumi@320w.f397a4a7.png";